// source: pbtypes/vehicle/return_manager/active_return_info.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_vehicle_return_manager_return_reason_pb = require('../../../pbtypes/vehicle/return_manager/return_reason_pb.js');
goog.object.extend(proto, pbtypes_vehicle_return_manager_return_reason_pb);
var pbtypes_vehicle_return_manager_return_type_pb = require('../../../pbtypes/vehicle/return_manager/return_type_pb.js');
goog.object.extend(proto, pbtypes_vehicle_return_manager_return_type_pb);
var pbtypes_vehicle_return_manager_stored_waypoint_pb = require('../../../pbtypes/vehicle/return_manager/stored_waypoint_pb.js');
goog.object.extend(proto, pbtypes_vehicle_return_manager_stored_waypoint_pb);
goog.exportSymbol('proto.return_manager.ActiveReturnInfo', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.return_manager.ActiveReturnInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.return_manager.ActiveReturnInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.return_manager.ActiveReturnInfo.displayName = 'proto.return_manager.ActiveReturnInfo';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.return_manager.ActiveReturnInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.return_manager.ActiveReturnInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.return_manager.ActiveReturnInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.return_manager.ActiveReturnInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
waypointKey: jspb.Message.getFieldWithDefault(msg, 1, 0),
reason: jspb.Message.getFieldWithDefault(msg, 2, 0),
returnType: jspb.Message.getFieldWithDefault(msg, 3, 0),
returnHeading: (f = jspb.Message.getOptionalFloatingPointField(msg, 4)) == null ? undefined : f,
remainingDistance: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
remainingTime: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.return_manager.ActiveReturnInfo}
 */
proto.return_manager.ActiveReturnInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.return_manager.ActiveReturnInfo;
  return proto.return_manager.ActiveReturnInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.return_manager.ActiveReturnInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.return_manager.ActiveReturnInfo}
 */
proto.return_manager.ActiveReturnInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.return_manager.StoredWaypointKeys.Enum} */ (reader.readEnum());
      msg.setWaypointKey(value);
      break;
    case 2:
      var value = /** @type {!proto.return_manager.ReturnReason.Enum} */ (reader.readEnum());
      msg.setReason(value);
      break;
    case 3:
      var value = /** @type {!proto.return_manager.ReturnType.Enum} */ (reader.readEnum());
      msg.setReturnType(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setReturnHeading(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setRemainingDistance(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setRemainingTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.return_manager.ActiveReturnInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.return_manager.ActiveReturnInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.return_manager.ActiveReturnInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.return_manager.ActiveReturnInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWaypointKey();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getReason();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getReturnType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = message.getRemainingDistance();
  if (f !== 0.0) {
    writer.writeFloat(
      5,
      f
    );
  }
  f = message.getRemainingTime();
  if (f !== 0.0) {
    writer.writeFloat(
      6,
      f
    );
  }
};


/**
 * optional StoredWaypointKeys.Enum waypoint_key = 1;
 * @return {!proto.return_manager.StoredWaypointKeys.Enum}
 */
proto.return_manager.ActiveReturnInfo.prototype.getWaypointKey = function() {
  return /** @type {!proto.return_manager.StoredWaypointKeys.Enum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.return_manager.StoredWaypointKeys.Enum} value
 * @return {!proto.return_manager.ActiveReturnInfo} returns this
 */
proto.return_manager.ActiveReturnInfo.prototype.setWaypointKey = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional ReturnReason.Enum reason = 2;
 * @return {!proto.return_manager.ReturnReason.Enum}
 */
proto.return_manager.ActiveReturnInfo.prototype.getReason = function() {
  return /** @type {!proto.return_manager.ReturnReason.Enum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.return_manager.ReturnReason.Enum} value
 * @return {!proto.return_manager.ActiveReturnInfo} returns this
 */
proto.return_manager.ActiveReturnInfo.prototype.setReason = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional ReturnType.Enum return_type = 3;
 * @return {!proto.return_manager.ReturnType.Enum}
 */
proto.return_manager.ActiveReturnInfo.prototype.getReturnType = function() {
  return /** @type {!proto.return_manager.ReturnType.Enum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.return_manager.ReturnType.Enum} value
 * @return {!proto.return_manager.ActiveReturnInfo} returns this
 */
proto.return_manager.ActiveReturnInfo.prototype.setReturnType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional float return_heading = 4;
 * @return {number}
 */
proto.return_manager.ActiveReturnInfo.prototype.getReturnHeading = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.return_manager.ActiveReturnInfo} returns this
 */
proto.return_manager.ActiveReturnInfo.prototype.setReturnHeading = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.return_manager.ActiveReturnInfo} returns this
 */
proto.return_manager.ActiveReturnInfo.prototype.clearReturnHeading = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.return_manager.ActiveReturnInfo.prototype.hasReturnHeading = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional float remaining_distance = 5;
 * @return {number}
 */
proto.return_manager.ActiveReturnInfo.prototype.getRemainingDistance = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.return_manager.ActiveReturnInfo} returns this
 */
proto.return_manager.ActiveReturnInfo.prototype.setRemainingDistance = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional float remaining_time = 6;
 * @return {number}
 */
proto.return_manager.ActiveReturnInfo.prototype.getRemainingTime = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.return_manager.ActiveReturnInfo} returns this
 */
proto.return_manager.ActiveReturnInfo.prototype.setRemainingTime = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


goog.object.extend(exports, proto.return_manager);
